import { environment } from 'environments/environment';

let cachedLogoBase64: string | null = null;

/** Carga el logo Servifin como data-URI (cache en memoria). */
export function loadServifinLogoBase64(): Promise<string> {
  if (!environment.SERVIFIN_MODE) {
    return Promise.resolve('');
  }
  if (cachedLogoBase64) {
    return Promise.resolve(cachedLogoBase64);
  }
  const path = environment.SERVIFIN_LOGO_PATH || 'assets/img/SERVIFIN/logo_servifin.png';
  return fetch(path)
    .then(res => (res.ok ? res.blob() : Promise.reject()))
    .then(blob => new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        cachedLogoBase64 = (reader.result as string) || '';
        resolve(cachedLogoBase64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    }))
    .catch(() => {
      cachedLogoBase64 = '';
      return '';
    });
}
